import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard-client-container',
  templateUrl: './dashboard-client-container.component.html',
  styleUrls: ['./dashboard-client-container.component.scss']
})
export class DashboardClientContainerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
